<template>
  <div class="category">
    <el-card
      class="box-card"
      v-for="(item, index) in list"
      :key="index"
      :src="item"
    >
      <div slot="header" class="clearfix">
        <span style="color:rgb(120, 130, 125);">{{
          index == 0 ? "左边图片" : "右边图片"
        }}</span>
        <el-button
          style="float: right; padding: 3px 0;"
          type="text"
          @click="handleModify(item, index)"
          >修改</el-button
        >
        <!-- <el-button
          style="float: right; padding: 3px 0;color:#f56c6c;margin-right:20px;"
          type="text"
          @click="handleDelete(item,index)"
        >删除</el-button>-->
      </div>
      <el-image
        class="box-card-img"
        fit="fill"
        :src="imgUrl + item"
        @click="previewImg(item)"
      />
    </el-card>

    <el-drawer
      title="修改图片 (建议比例750:400,图片大小不得超过2MB)"
      :visible.sync="dialog"
      direction="btt"
      size="50%"
      class="drawer"
    >
      <div class="flex-view">
        <div class="flex-item">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击上传左边的图片"
            placement="top-start"
          >
            <div>
              <p>左边的图片</p>
              <el-upload
                class="avatar-uploader"
                :action="uploadAction"
                :show-file-list="false"
                :data="uploadToken"
                :on-success="
                  (res, file, fileList) =>
                    handleAvatarSuccess(res, file, fileList, 1)
                "
                :on-error="handleAvatarError"
                :before-upload="beforeAvatarUpload"
              >
                <el-image
                  class="box-card-img"
                  fit="contain"
                  v-if="form.pic_1"
                  :src="imgUrl + form.pic_1"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-tooltip>
        </div>
        <div class="flex-item">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击上传右边的图片"
            placement="top-start"
          >
            <div>
              <p>右边的图片</p>
              <el-upload
                class="avatar-uploader"
                :action="uploadAction"
                :show-file-list="false"
                :data="uploadToken"
                :on-success="
                  (res, file, fileList) =>
                    handleAvatarSuccess(res, file, fileList, 2)
                "
                :on-error="handleAvatarError"
                :before-upload="beforeAvatarUpload"
              >
                <el-image
                  class="box-card-img"
                  fit="contain"
                  v-if="form.pic_2"
                  :src="imgUrl + form.pic_2"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="closeDrawer" :loading="loading">{{
          loading ? "提交中 ..." : "确 定"
        }}</el-button>
      </div>
    </el-drawer>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="dialogVisible">
      <el-image :src="imgUrl + dialogVisibleImg" fit="fill" />
    </el-dialog>
  </div>
</template>
<script>
import { info, saveInfo } from "@/api/home";
export default {
  name: "category",
  data() {
    return {
      list: [], // 数据列表
      dialog: false, // 遮罩层
      loading: false, // 加载
      dialogVisible: false, // 预览图片
      dialogVisibleImg: "", // 预览图片地址
      uploadToken: {
        // 图片上传附带的token参数
        token: this.$store.getters.userinfo.login_token,
      },
      form: {
        // 上传图片表单
        pic_1: "",
        pic_2: "",
      },
    };
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      info().then((res) => {
        if (res.data) {
          this.list = [res.data.pic_1, res.data.pic_2];
        } else {
          this.list = ["", ""];
        }
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    // 预览病科图片
    previewImg(url) {
      this.dialogVisible = true;
      this.dialogVisibleImg = url;
    },
    // 修改
    handleModify() {
      this.form.pic_1 = this.list[0];
      this.form.pic_2 = this.list[1];
      this.dialog = true;
    },
    // 关闭侧栏
    closeDrawer() {
      if (this.form.pic_1 != "" && this.form.pic_1 != "") {
        this.$confirm("确定要提交吗？")
          .then(() => {
            this.loading = true;
            saveInfo(this.form)
              .then(() => {
                this.$store.dispatch("fullscreenLoading", true);
                this.getData();
                this.loading = false;
                this.dialog = false;
                this.$message.success("提交成功");
                this.form = {
                  pic_1: "",
                  pic_2: "",
                };
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      } else {
        this.$message.error("两边的图片都需要上传到哦(๑•ᴗ•๑)");
      }
    },
    // 删除
    handleDelete(item, index) {
      this.$confirm("删除之后小程序首页将不显示", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.list.splice(index, 1);
        this.$message.success("删除成功!");
      });
    },
    // 图片上传成功
    handleAvatarSuccess(res, file, fileList, index) {
      this.$message.closeAll();
      this.$message.success("上传成功");
      const { path, filename } = res.data.files[0];
      if (index == 1) {
        this.form.pic_1 = path + filename;
      } else {
        this.form.pic_2 = path + filename;
      }
    },
    // 图片上传失败
    handleAvatarError(res) {
      this.$message.closeAll();
      this.$message.error("上传失败" + res);
    },
    // 图片上传之前
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      this.$message({
        showClose: true,
        duration: 0,
        message: "正在上传，请稍后...",
      });
      return isLt2M;
    },
  },
};
</script>

<style scoped>
.category {
  display: flex;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 400px;
  margin: 0 20px 20px 0;
}

.box-card-img {
  height: 214px;
}

/* drawer */
.el-drawer__body {
  padding: 0 20px;
}

.demo-drawer__footer {
  margin: 50px auto 0 auto;
  text-align: center;
}

/* flex布局 */
.flex-view {
  display: flex;
  justify-content: space-around;
}

.flex-item {
  width: 40%;
  max-height: 250px;
  text-align: center;
}
</style>
